import React, { useState } from "react";
import "@ant-design/compatible/assets/index.css";
import { Button, Collapse, DatePicker, Select, Form, message, Checkbox } from "antd";
import moment from "moment";

import HMGSelect from "../../components/Common/DataAttachedElements/HMGSelect";
import ProjectSelect from "../../components/Common/DataAttachedElements/ProjectSelect";
import HotelDropdown from "../../components/Common/DataAttachedElements/HotelDropdown";

import { useGetHotelById } from "../../hooks/hotel.hooks";
import { useRequestHotelQc } from "../../hooks/qcApi.hooks";

import { formItemLayout, formItemLayoutWithOutLabel } from "../../utils/UI";

const { Panel } = Collapse;
const { RangePicker } = DatePicker;

const HotelQc = () => {
  const [form] = Form.useForm();

  const [hmg, setHmg] = useState();
  const [project, setProject] = useState();
  const [hotels, setHotels] = useState();
  const [date, setDate] = useState();
  const [checkDateRange, setCheckDateRange] = useState(false);
  const [dateRange, setDateRange] = useState();
  const [emails, setEmails] = useState();

  const { data: hotelsList } = useGetHotelById(hotels, {
    enabled: !!hotels,
  });

  const emailValidator = async (rule, values) => {
    if (values && values.length > 0) {
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const invalidInputs = values.filter(
        (value) => !value.match(emailRegex)
      );
      if (invalidInputs.length === 0) {
        return Promise.resolve();
      } else if (invalidInputs.length === 1) {
        return Promise.reject(
          invalidInputs.join("") + " is not a valid email"
        );
      } else {
        return Promise.reject(
          invalidInputs.slice(0, -1).join(", ") +
          " and " +
          invalidInputs.slice(-1) +
          " are not valid emails"
        );
      }
    } else {
      return Promise.reject("Please Enter Emails");
    }
  };

  const { mutate: requestHotelQc } = useRequestHotelQc({
    onSuccess: (response) => {
      message.success(response.message);
      clearFields();
    },
    onError: (error) => {
      // console.log(error);
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const clearFields = () => {
    form.resetFields();
    setHmg(null);
    setProject(null);
    setHotels(null);
    setDate(null);
    setCheckDateRange(false);
    setDateRange(null);
    setEmails(null);
  };

  const requestHotelReport = () => {
    requestHotelQc({
      emails: emails.join('|'),
      date_range_picker: checkDateRange,
      date_range: dateRange,
      date: moment(date).format("MM/DD/YYYY"),
      hotel:(process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT") ? hotelsList.hotel_code : hotelsList.hotel_name
    });
  }

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
          <Panel header="Hotel QC (Ad hoc)" key="1">
            <Form form={form}>
              <Form.Item
                {...formItemLayout}
                name={"HMG"}
                label="Hotel Management Group"
                placeholder="Please Select Hotel Management Group"
                rules={[
                  {
                    required: true,
                    message: "Hotel Management Group required",
                  },
                ]}
              >
                <HMGSelect value={hmg} onChange={setHmg} />
              </Form.Item>
              <Form.Item
                {...formItemLayout}
                name="Project"
                label="Project" >
                <ProjectSelect
                  value={project}
                  onChange={setProject}
                  hmgId={hmg}
                  placeholder="Please Select Project"
                  solution="PNA" />
              </Form.Item>
              <HotelDropdown
                value={hotels}
                onChange={setHotels}
                projectId={project}
                multiple={false}
              />
              <Form.Item
                {...formItemLayout}
                name="businessDate"
                label="Date"
                placeholder="Please Enter Date"
              >
                {!checkDateRange ?
                  <DatePicker
                    disabledDate={(current) =>
                      current > moment()
                    }
                    format="YYYY-MM-DD"
                    placeholder="Please Enter Date"
                    style={{ width: "calc(100% - 110px)" }}
                    value={date}
                    onChange={setDate}
                  />
                  :
                  <RangePicker
                    value={dateRange}
                    style={{ width: "calc(100% - 110px)" }}
                    onChange={setDateRange}
                  />
                }
                <Checkbox
                  checked={checkDateRange}
                  onChange={(e) => setCheckDateRange(e.target.checked)}
                  style={{ marginLeft: "5px" }}>
                  Date Range
                </Checkbox>
              </Form.Item>
              <Form.Item
                {...formItemLayout}
                name="emails"
                label="E-mails :"
                rules={[
                  {
                    validator: emailValidator,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Enter Emails"
                  optionFilterProp="children"
                  mode="tags"
                  value={emails}
                  onChange={setEmails}
                  notFoundContent={null}
                ></Select>
              </Form.Item>
              <Form.Item {...formItemLayoutWithOutLabel}>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={!(hotels && (checkDateRange ? dateRange : date) && emails)}
                  onClick={requestHotelReport}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Panel>
        </Collapse>
      </div>
    </>
  );
}

export default HotelQc;
